import { useTranslation } from "react-i18next";

/**
 * Clear link for filter bars. Convention: never clears Period — only
 * non-period filters. Render only when those filters are active.
 */
const TableFilterClearLink = ({
  visible = false,
  onClear,
  className = "",
  label,
}) => {
  const { t } = useTranslation();

  if (!visible || typeof onClear !== "function") {
    return null;
  }

  return (
    <button
      type="button"
      onClick={onClear}
      className={`italic text-sm text-gray-400 hover:text-gray-600 transition-colors ml-1 ${className}`.trim()}
    >
      {label || t("Clear filters")}
    </button>
  );
};

/**
 * Returns true when at least one non-period filter differs from its default.
 * Pass only clearable (non-period) filter entries.
 *
 * @param {Array<{ value: unknown, defaultValue?: unknown }>} entries
 */
export const hasActiveClearableFilters = (entries = []) =>
  entries.some(({ value, defaultValue = "all" }) => {
    if (typeof value === "string") {
      const normalized = value.trim();
      const normalizedDefault =
        typeof defaultValue === "string" ? defaultValue.trim() : defaultValue;
      return normalized !== normalizedDefault;
    }
    if (Array.isArray(value)) {
      const defaultArray = Array.isArray(defaultValue) ? defaultValue : [];
      return value.length !== defaultArray.length;
    }
    if (typeof value === "number") {
      return value !== defaultValue;
    }
    return value != null && value !== defaultValue;
  });

export default TableFilterClearLink;
